'use client';

import useViewportListener from '@/lib/hooks/use-viewport-listener';

const ViewportListenerClient = () => {
  useViewportListener();
  return null;
};

export default ViewportListenerClient;
